import HeroSection from "../components/sections/HeroSection";
import NewsSection from "../components/sections/NewsSection";
import AboutSection from "../components/sections/AboutSection";
import AssortmentSection from "../components/sections/AssortmentSection";
import ContactSection from "../components/sections/ContactSection";
import SiteNotice from "../components/sections/SiteNotice";

function Home() {
    return (
        <>
            <HeroSection />
            <SiteNotice />
            <AboutSection />
            <AssortmentSection />
            <NewsSection />
            <ContactSection />
        </>
    );
}

export default Home;